import { useRef } from 'react';
import { useSearchParams } from 'react-router';
import { useSetAtom } from 'jotai';
import { useFilterToUrlParser } from 'src/common/components/Filters/hooks/useFilterToUrlParser';
import { simInventoryUrlParamsAtom } from 'src/atoms/filters/sim';

export const SimInventoryFiltersURLParser = ({ children }: { children: React.ReactElement }) => {
  const [searchParams] = useSearchParams();
  const setURLParams = useSetAtom(simInventoryUrlParamsAtom);
  const isMounted = useRef(false);

  useFilterToUrlParser(
    {
      urlSearchParamsAtom: simInventoryUrlParamsAtom,
    },
    isMounted.current,
  );

  if (!isMounted.current) {
    setURLParams(searchParams);
    isMounted.current = true;
  }

  return <>{children}</>;
};
